export default __webpack_public_path__ + "static/media/copyIcon.ec69a126.svg";